export enum ConfigManagerProperties {
  buildVersion = 'buildVersion',
  production = 'production',
  region = 'region',
}
